var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowLeft = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.259,
    height: 7.549,
    viewBox: "0 0 8.259 7.549",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M.249,5.154A.783.783,0,0,1,1.334,4.026l1.655,1.6V.774a.785.785,0,0,1,1.57,0V5.627l1.656-1.6A.783.783,0,0,1,7.3,5.154L4.359,8A.788.788,0,0,1,3.19,8Z",
    transform: "translate(8.259) rotate(90)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left.2c03d251.svg";
export { ForwardRef as ReactComponent };